/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:26
 * @LastEditTime: 2021-07-20 18:19:38
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\departmenManusManageMent\departmentManuRouter.js
 * @Description: 
 */
'use strict';
angular.module('departmentManuRouterModule',
    [
        'companyManageModule',
        'departmentManageModule',
        'departmentManuLeftModule',
        'departmentManuCommonServiceModule',
    ]).config(['$stateProvider', function($stateProvider) {
    // $stateProvider.state('manageconfig.departmentmanu', {
    //     url: '/departmentmanu',
    //     views: {
    //         'main@manageconfig': {
    //             templateUrl: './manageConfig/departmenManusManageMent/main_tpl.html'
    //         },
    //         'left@manageconfig.departmentmanu': {
    //             templateUrl: './manageConfig/departmenManusManageMent/left_tpl.html',
    //             controller: 'departmentManuLeftCtrl',
    //         }
    //     }
    // }).state('manageconfig.departmentmanu.companymanage', {
    //     url: '/companymanage', // 单位管理
    //     views: {
    //         'right@manageconfig.departmentmanu': {
    //             templateUrl: './manageConfig/departmenManusManageMent/companyManage/main_tpl.html',
    //             controller: 'companyManageController'
    //         },
    //     }
    // }).state('manageconfig.departmentmanu.departmentmanage', {
    //     url: '/departmentmanu?parentid', // 部门管理
    //     views: {
    //         'right@manageconfig.departmentmanu': {
    //             templateUrl: './manageConfig/departmenManusManageMent/departmentManage/main_tpl.html',
    //             controller: 'departmentManageController'
    //         },
    //     }
    // });
}]);
